export const border = {
  borderColour: {
    borderE0E3E1: "#E0E3E1",
    borderDivider: "divider",
    border6F7976: "#6F7976"
  },
  borderWidth: 1,
  borderWidth0: 0
};
